import { Link } from 'react-router-dom';
import type { Episode } from '@/mocks/episodes';
import { formatDate } from '@/lib/content';

interface EpisodeCardProps {
  episode: Episode;
  dramaTitle?: string;
}

export default function EpisodeCard({ episode, dramaTitle }: EpisodeCardProps) {
  const target = episode.aired ? `/play/${episode.id}` : `/detail/${episode.dramaId}`;

  return (
    <Link
      to={target}
      className="group flex gap-4 rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 p-3"
    >
      <div className="relative w-32 sm:w-40 shrink-0 aspect-video rounded-md overflow-hidden bg-background-200">
        <img
          src={episode.thumb}
          alt={`第${episode.number}集 剧照`}
          title={`迷人的保姆 第${episode.number}集 ${episode.title}`}
          className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute bottom-1.5 right-1.5 px-1.5 py-0.5 rounded bg-primary-950/80 text-background-50 text-[10px] font-label">
          {episode.aired ? '第' + episode.number + '集' : '待更新'}
        </span>
        {episode.isNew && (
          <span className="absolute top-1.5 left-1.5 px-1.5 py-0.5 rounded bg-accent-500 text-background-50 dark:text-foreground-950 text-[10px] font-medium">
            最新
          </span>
        )}
      </div>
      <div className="flex flex-col justify-center min-w-0 py-1">
        <div className="flex items-center gap-2 flex-wrap">
          <h3 className="font-semibold text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
            {episode.title}
          </h3>
          <span className="text-xs text-foreground-500 shrink-0">第 {episode.number} 集</span>
        </div>
        {dramaTitle && <p className="text-xs text-secondary-700 mt-1">{dramaTitle}</p>}
        <p className="text-xs text-foreground-600 mt-1.5 line-clamp-2">{episode.summary}</p>
        <div className="mt-2 flex items-center gap-3 text-[11px] text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {episode.aired ? episode.duration : '未播出'}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {episode.aired ? formatDate(episode.publishedAt) : '待定'}
          </span>
        </div>
      </div>
    </Link>
  );
}